export const stripe_public_key = "pk_live_51NkSO9E6jR5FXDfMOwtpQXwY7nLCILhITsTxUQereaZv08xNg3VIDDmTnvJ17tj3f1pphbWZpRHFvNUhAtuez4DR005Z0ecTlC" // Netherlands
// export const stripe_public_key = "pk_live_51HfS0TI53KBqdjiviYCnrrCESsaw7pHFZzv6s5061himHfFj6VYQ3GE5AcWIB3ZMAkBhbxU4Y6qSoAwT3Tk5KDE600SuWde5mI" // Austria
// export const stripe_public_key = "pk_test_51HfS0TI53KBqdjiv9WkhXaZXK1NEjXdiX1rdFFizjED5t7OAr3qg8b5ZB1guL0JPJJYjL7qrzZYjJS3DEYViM3rt00Bwzj9pNO"

